// const pdfjs = await import("pdfjs-dist/build/pdf");
// const pdfjsWorker = await import("pdfjs-dist/build/pdf.worker.entry");
import { pdfjs } from "react-pdf";

// pdfjs.GlobalWorkerOptions.workerSrc =
//   "../../../../node_modules/pdfjs-dist/build/pdf.worker.js";

if (pdfjs.version >= "4.0.189") {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
} else {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
}
// pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
/**
 * Reads the data of a file and returns it as a base64 string.
 *
 * @param file - The file to be read.
 * @returns A promise that resolves with the file data as a base64 string.
 */
export const readFileData = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      resolve(e.target?.result);
    };
    reader.onerror = err => {
      reject(err);
    };
    reader.readAsDataURL(file);
  });
};

// param: file -> the input file (e.g. event.target.files[0])
// return: images -> an array of images encoded in base64
/**
 * Converts a PDF file or base64 string into an array of images encoded in base64.
 *
 * @param file - The PDF file to be converted. If not provided, the base64 string will be used.
 * @param base64 - An optional base64 string representation of the PDF file.
 * @returns A promise that resolves with an array of base64-encoded images.
 */
export const convertPdfToImages = async (
  file: File | undefined,
  base64: string = "",
) => {
  const images = [];
  let data = base64;
  if (file) data = (await readFileData(file)) as string;
  const pdf = await pdfjs.getDocument(data).promise;
  const canvas = document.createElement("canvas");
  for (let i = 0; i < pdf.numPages; i++) {
    const page = await pdf.getPage(i + 1);
    const viewport = page.getViewport({ scale: 2 });
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    await page.render({ canvasContext: context, viewport }).promise;
    images.push(canvas.toDataURL());
  }
  canvas.remove();
  return images;
};
